// import React, { useContext, useEffect, useRef, useState } from "react";
import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";

import axios from "axios";
import config from "../../../config/config";
import Select from "react-select";
import moment from "moment";
import { CommonHandleFileChange } from "../../../common/common";
import { toastError, toastSuccess, toastWarn } from "../../../common/Toast";
import PaybillsSteppermodal from "../../../components/Modal/PaybillsSteppermodal";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";
import MissingTransaction from "../../../components/Modal/MissingTransaction";
import { AppContext } from "../../../context/AppContext";
import RecentTransactionsModal from "../../../components/Modal/RecentTransactionsModal";
import CurrencySymbols from "../../../common/CurrencySymbol";
import DeleteConfirmation from "../../../components/Modal/DeleteConfirmation";
import RollbackReceivePayment from "../../../components/Modal/RollbackReceivePayment";
import QuickbookSyncMessageComponent from "../../../components/StoreConfig/QuickbookSyncMessageComponent";
import { checkUserPermission } from "../../../common/UserPermission";

function PayBillsQuickbook() {
  const {
    isManageSale,
    isManagePOSSale,
    CurrencySymbol,
    FractionDigits,
    AllowQBSync,
    enableAutoSuggestCreditBillPayment
  } = useContext(AppContext);
  let navigate = useNavigate();
  const paramObject = useParams();

  let DELETEPERMISSION = "/delete-paybills";
  const { missingtransaction, missingtransactions } = useContext(AppContext);
  useEffect(() => {
    if (paramObject.id > 0) {
      let reqob = {
        Module: "receivings_transactions",
        Id: paramObject.id,
      };
      missingtransaction(reqob);
    }
  }, []);
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const locationId = localStorage.getItem("Location");
  const [loading, setLoading] = useState(false);
  const handleOpenRef = useRef(null);
  const [supplierId, setSupplierId] = useState(0);
  const [supplierName, setSupplierName] = useState("");
  const [supplierQuickBookId, setSupplierQuickBookId] = useState(0);
  const [TxnQuickbookid, setTxnQuickbookid] = useState(0);

  const [findBillByInvoicveNo, setFindBillByInvoicveNo] = useState(0);

  const [showOpenInvoiceError, setShowOpenInvoiceError] = useState(false); // if any open invoice is not exist
  const [fileddata, setduleddata] = useState("");
  const [paymentDate, setPaymentDate] = useState(moment().format("YYYY-MM-DD"));

  const [paymentMethod, setPaymentMethod] = useState([]);
  const [paymentMethodId, setPaymentMethodId] = useState(0);
  const [prevPaymentMethodId, setPrevPaymentMethodId] = useState(0);
  const [prevRefNum, setPrevRefNum] = useState("");
  const [prevDepositTo, setPrevDepositTo] = useState(0);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [printLater, setPrintLater] = useState(false);
  const [paymentQuickbookId, setPaymentQuickbookId] = useState(0);

  const [referenceNumber, setReferenceNumber] = useState("");

  const [depositToAccount, setDepositToAccount] = useState([]);
  const [depositTo, setDepositTo] = useState(0);
  const [depositToAccountQuickbookId, setDepositToAccountQuickbookId] =
    useState(0);

  const [attachmentUrl, setAttachmentUrl] = useState("");
  const [memoData, setMemoData] = useState("");

  console.log(attachmentUrl, "attachmentUrl");

  
  const [showSupplierBalance, setShowSupplierBalance] = useState(false);

  const [totalReceivingAmountInput, setTotalReceivingAmountInput] = useState(0);
  const [totalReceivingAmount, setTotalReceivingAmount] = useState(0);
  const [totalReceivingInvoiceAmount, setTotalReceivingInvoiceAmount] =
    useState(0);
  const [totalReceivingCreditAmount, setTotalReceivingCreditAmount] =
    useState(0);
  // const [selectedSupplierTotalBalance, setSelectedSupplierTotalBalance] = useState(0);

  const [supplier, setSupplier] = useState([]);
  const [supplierInvoiceData, setSupplierInvoiceData] = useState([]);
  const [supplierCreditData, setSupplierCreditData] = useState([]);
  const [receivedata, setreceivedata] = useState("");

  const [showInvoiceNotFound, setShowInvoiceNotFound] = useState(false); //
  const [showPaymentDateError, setShowPaymentDateError] = useState(false);
  const [showPaymentMethodError, setShowPaymentMethodError] = useState(false);
  const [showDepositToError, setShowDepositToError] = useState(false);
  const [showReferenceNumberError, setShowReferenceNumberError] =
    useState(false);
  const [showAmountReceivedError, setShowAmountReceivedError] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [IsRollback, setIsRollback] = useState(false);
  const [RollbackOriginalId, setRollbackOriginalId] = useState(0);
  const [supplierOpenBalance, setSupplierOpenBalance] = useState(0);
  const [RollbackId, setRollbackId] = useState(0);
  console.log(supplierInvoiceData, "supplierInvoiceData");
  console.log(supplierCreditData, "supplierInvoiceData");
  console.log(supplierId, "supplierId12121");
  console.log(receivedata, "receivedata12121");
  console.log(enableAutoSuggestCreditBillPayment, "enableAutoSuggestCreditBillPayment");

  const [QBpermission, setqbpermission] = useState(true);

  const handlepermission = () => {
    axios
      .get(`${config.salesconfigBaseUrl}/receivings/BillPaymentPermission`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res.data.ResponseData[0].AppConfigvalue, "123");
        if (res.data.ResponseData[0].AppConfigvalue == "false") {
          setqbpermission(false);
        } else {
          setqbpermission(true);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    handlepermission();
  }, []);

  const ParticularSupplierInvoiceAPI = (
    p_supplierid,
    p_invoicenumber,
    p_location,
    trans
  ) => {
    // console.log(p_supplierid, p_invoicenumber, "supplierDataList");
    setLoading(true);
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/paybill_list_V2?supplierId=${
          p_supplierid ? p_supplierid : 0
        }&invoiceno=${
          p_invoicenumber ? p_invoicenumber : 0
        }&LocationID=${locationId}&TxnID=${
          paramObject?.id == undefined
            ? 0
            : trans === "new"
            ? 0
            : paramObject?.id
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          if (res.data.ResponseData[0]?.IsRollback != 1) {
            const mappedReceivingItems = res.data.ResponseData.map((item) => {
              return {
                ...item,
                // Payment: null,
                // Openingbalance: Number(item?.Openingbalance),
                // OriginalAmount: Number(item?.OriginalAmount),
                // CreditAppiedValue: null,
                isChecked: item?.isChecked === 1 ? true : false,
                Payment: Number(item?.AmountPaid),
                // PaymentMethod: 0,
                // SupplierID: p_supplierid,
                // SupplierTotalBalance: 50000,
                // InvoiceDate: moment(),
              };
            });

            const creditData = mappedReceivingItems?.filter(
              (el) => el?.Type !== "Bill" && el?.Type !== "Deposit"
            );
            const InvoiceData = mappedReceivingItems?.filter(
              (el) => el?.Type === "Bill" || el?.Type === "Deposit"
            );

            if (InvoiceData?.length > 0 && p_supplierid > 0) {
              setShowOpenInvoiceError(false);
            } else {
              if (p_supplierid !== 0) {
                if (p_invoicenumber > 0) {
                  setShowOpenInvoiceError(false);
                } else {
                  setShowOpenInvoiceError(true);
                }
              }
            }

            const InvoicesortedArray = InvoiceData.sort((a, b) => {
              const dueDateDiff = new Date(a.DueDate) - new Date(b.DueDate);
              if (dueDateDiff !== 0) return dueDateDiff;

              const invoiceDateDiff =
                new Date(a.BillDate) - new Date(b.BillDate);
              if (invoiceDateDiff !== 0) return invoiceDateDiff;

              const qbdiffer =
                Number(a.BillQuickbookId) - Number(b.BillQuickbookId);
              if (qbdiffer !== 0) return qbdiffer;

              const CreatedDateOrderdiffer =
                new Date(a.CreatedDateOrder) - new Date(b.CreatedDateOrder);
              if (CreatedDateOrderdiffer !== 0) return CreatedDateOrderdiffer;

              return 0; // <-- Ensure a value is always returned
            });

            console.log(InvoicesortedArray, "writeone");

            console.log(InvoicesortedArray, "writeone");

            let JournalEntry = creditData.filter(
              (item) =>
                (item.Type === "VendorCredit" && item.IsJournalEntry === 1) ||
                item.Type === "unappliedpayment"
            );

            let VendorCredit = creditData.filter(
              (item) =>
                (item.Type === "VendorCredit" && item.IsJournalEntry === 0 || item.Type === "Expense")
            );

            const journalsortArray = JournalEntry.sort((a, b) => {
              const dueDateDiff = new Date(a.DueDate) - new Date(b.DueDate);
              if (dueDateDiff !== 0) return dueDateDiff;

              const invoiceDateDiff =
                new Date(a.BillDate) - new Date(b.BillDate);
              if (invoiceDateDiff !== 0) return invoiceDateDiff;

              const qbdiffer =
                Number(a.BillQuickbookId) - Number(b.BillQuickbookId);
              if (qbdiffer !== 0) return qbdiffer;

              const CreatedDateOrderdiffer =
                new Date(a.CreatedDateOrder) - new Date(b.CreatedDateOrder);
              if (CreatedDateOrderdiffer !== 0) return CreatedDateOrderdiffer;

              return 0; // <-- Ensure a value is always returned
            });

            const VendorCreditArray = VendorCredit.sort((a, b) => {
              const dueDateDiff = new Date(a.DueDate) - new Date(b.DueDate);
              if (dueDateDiff !== 0) return dueDateDiff;

              const invoiceDateDiff =
                new Date(a.BillDate) - new Date(b.BillDate);
              if (invoiceDateDiff !== 0) return invoiceDateDiff;

              const qbdiffer =
                Number(a.BillQuickbookId) - Number(b.BillQuickbookId);
              if (qbdiffer !== 0) return qbdiffer;

              const CreatedDateOrderdiffer =
                new Date(a.CreatedDateOrder) - new Date(b.CreatedDateOrder);
              if (CreatedDateOrderdiffer !== 0) return CreatedDateOrderdiffer;

              return 0; // <-- Ensure a value is always returned
            });

            let creditDatasortedArray = [
              ...journalsortArray,
              ...VendorCreditArray,
            ];

            setShowInvoiceNotFound(false);
            setSupplierCreditData(
              creditDatasortedArray?.map((el) => ({
                ...el,
                isBill: 0,
                isCreditJournalEntry: el?.IsJournalEntry,
              }))
            );
            setSupplierInvoiceData(
              InvoicesortedArray?.map((el) => ({
                ...el,
                isBill: 1,
                isCreditJournalEntry: 0,
              }))
            );

            if (p_supplierid > 0 || mappedReceivingItems?.length > 0) {
              setSupplierId(
                p_supplierid > 0
                  ? p_supplierid
                  : mappedReceivingItems[0]?.SupplierID
              ); //  ---commented code---
              setSupplierName(mappedReceivingItems[0]?.SupplierName); //
              //
              // setSelectedSupplierTotalBalance(
              //   mappedReceivingItems[0]?.SupplierBalance        //
              //     ? mappedReceivingItems[0]?.SupplierBalance
              //     : 0
              // );
            }

            if (paramObject.id !== undefined) {
              console.log("setSupplierQuickBookId");
              setSupplierQuickBookId(
                mappedReceivingItems[0]?.SupplierQuickbookID
              );
              setTxnQuickbookid(mappedReceivingItems[0].TxnQuickbookid);
              setPrintLater(
                mappedReceivingItems[0]?.PrintStatus == 1 ? true : false
              );
              setFindBillByInvoicveNo(0);
              setPaymentDate(
                mappedReceivingItems[0]?.PaymentDateAll
                  ? moment(mappedReceivingItems[0]?.PaymentDateAll).format(
                      "YYYY-MM-DD"
                    )
                  : moment().format("YYYY-MM-DD")
              );
              setPaymentMethodId(mappedReceivingItems[0]?.PaymentMethodIdAll); //
              setPrevPaymentMethodId(
                mappedReceivingItems[0]?.PaymentMethodIdAll
              ); //
              setPaymentQuickbookId(
                mappedReceivingItems[0]?.PaymentMethodQuickbookIdAll //
              );
              setReferenceNumber(mappedReceivingItems[0]?.ReferenceNumberAll); //
              setPrevRefNum(mappedReceivingItems[0]?.ReferenceNumberAll); //
              setDepositTo(mappedReceivingItems[0]?.DepositToAll); //
              setPrevDepositTo(mappedReceivingItems[0]?.DepositToAll); //
              setDepositToAccountQuickbookId(
                mappedReceivingItems[0]?.DepositToAccountQuickbookIdAll //
              );
              setMemoData(mappedReceivingItems[0]?.MemoDataAll); //
              setAttachmentUrl(mappedReceivingItems[0]?.AttachmentUrlAll); //
            }

            if (paramObject.id !== undefined) {
              setTimeout(() => {
                setTotalReceivingAmount(
                  Number(mappedReceivingItems[0]?.TotalReceivedAmount) //
                );
                setShowAmountReceivedError(false);
              }, 500);
            }
            localStorage.removeItem("paybillSupplierid");
          } else {
            setIsRollback(
              res.data.ResponseData[0]?.IsRollback == 1 ? true : false
            );
            setRollbackOriginalId(res.data.ResponseData[0]?.RollbackOriginalId);
            setRollbackId(res.data.ResponseData[0]?.RollbackId);
          }
        } else {
          // setSupplierId(0);
          setShowInvoiceNotFound(true);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  // Supplier Drop Down Binding API CALL
  const SupplierAPI = () => {
    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        const supplierOption = response.data.ResponseData.map((u) => ({
          label: `${u.CompanyName} (${u.FirstName} ${u.LastName})`,
          value: u.ID,
          quickbookid: u.QuickBookId,
          Balance: u.Balance,
        }));
        setSupplier(supplierOption);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Payment Method Drop Down Binding API CALL
  const PaymentMethodAPI = () => {
    axios
      .get(
        `${config.generalBaseUrl}/generals/transactionpaymentdropdown?module=pay_bill`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const Option = res.data.ResponseData.map((u) => ({
          label: u.Paymenttypename,
          value: u.ID,
          paymentquickbookid: u.PaymentQuickbookId,
        }));

        setPaymentMethod(Option);
      });
  };

  const DepositTOAccountAPI = () => {
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/accountddl`, //?type=3&undepositedfunds=true
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("ChartOfAccountDropdown", res.data.ResponseData);
        const mappedReceivingItems = res.data.ResponseData.filter(
          (item) =>
            item.AccountType == "Credit Card" || item.AccountType == "Bank"
        ).map((item) => {
          const mappedItem = {
            label: item.Name,
            value: item.ID,
            Amount: item.Amount,
            DepositQuickbookId: item.QuickbookId,
            AccountType: item.AccountType,
            parentName: item.ParentName ? item.ParentName.trim() : ""
          };
          return mappedItem;
        });
        // setStateNew(mappedReceivingItems);
        setDepositToAccount(mappedReceivingItems);
        // return res;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const latestCheckNumberAPI = () => {
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/getlatestchecknumberbyaccount?accountid=${depositTo}&paymenttypeid=${paymentQuickbookId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )

      .then((res) => {
        console.log(res.data.ResponseData, "resDatacheking");
        let takeNumber = res.data.ResponseData[0]?.NextRefno;
        console.log(takeNumber, "takeNumber");

        setReferenceNumber(takeNumber);
        // setLoading(false);
      });
  };

  const callSupplierGetApi = (ID) => {
    axios
      .get(
        `${config.suppliersBaseUrl}/suppliers/supplierbalancebyid?id=${ID}&location=${locationId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        if (
                 response.data.ResponseData?.length > 0
               ) {
                 let supplierData = response.data.ResponseData[0];
                 setSupplierOpenBalance(supplierData.OpenBalance);
                //  setBalanceLoading(false);
               }
      })
      .catch((error) => {
        // setBalanceLoading(false);
        console.log(error);
      });
  };

  const checkBalance = ()=> {
    setShowSupplierBalance(true);
    callSupplierGetApi(supplierId);
  }

  // useEffect(() => {
  //   callSupplierGetApi(supplierId);
  // }, [supplierId]);

  useEffect(() => {
    SupplierAPI();
    PaymentMethodAPI();
    DepositTOAccountAPI();
    const storedUserId = localStorage.getItem("paybillSupplierid");
    // if (paramObject.id !== undefined) {
    //   ParticularSupplierInvoiceAPI(0, 0);
    // } else
    if (storedUserId !== null) {
      ParticularSupplierInvoiceAPI(parseInt(storedUserId, 10), 0);
    }
  }, []);

  useEffect(() => {
    if (
      (selectedPaymentType == "Check" || selectedPaymentType == "Cash") &&
      (depositTo > 0 || depositTo != "")
      && (paramObject.id !== undefined
        ? (prevPaymentMethodId != paymentMethodId || prevDepositTo != depositTo) ? true : setReferenceNumber(prevRefNum)
        : true)
    ) {
      latestCheckNumberAPI();
    }
  }, [selectedPaymentType, depositTo]);

  useEffect(() => {
    if (paramObject.id !== undefined) {
      ParticularSupplierInvoiceAPI(0, 0);
    }
  }, [paramObject.id]);

  useEffect(() => {
    let match = paymentMethod.find((item) => item.value == paymentMethodId);
    if (match) {
      setSelectedPaymentType(match.label);
    }
  }, [paymentMethodId, paymentMethod]);

  const handleFindData = () => {
    ParticularSupplierInvoiceAPI(0, findBillByInvoicveNo);
  };

  // handle change for all the input fields
  const handleChangeInput = (event, fieldName, index) => {
    // console.log(event, fieldName, index, "change event")

    if (fieldName === "Supplier") {
      // console.log(event?.value, fieldName, "supplier 456");
      // console.log(event, "event==>");
      setSupplierQuickBookId(
        event?.quickbookid === undefined ? 0 : event?.quickbookid
      );
      setShowSupplierBalance(false);
      // setSelectedSupplierTotalBalance(
      //   event?.Balance === undefined ? 0 : event?.Balance
      // );
      ParticularSupplierInvoiceAPI(
        event?.value === undefined ? 0 : event?.value,
        findBillByInvoicveNo
      );
      setSupplierId(event?.value === undefined ? 0 : event?.value);
      setSupplierName(event?.label === undefined ? 0 : event?.label);
      // setFormValues((prevValues) => ({
      //   ...prevValues,
      //   [fieldName]: event?.value,
      // }));

      // if (event?.value != undefined) {
      //   setShowAccountSelectError(false);
      // } else {
      //   setShowAccountSelectError(true);
      // }
    } else if (fieldName === "InvoiceNumber") {
      // console.log(event.target.value, fieldName);
      setFindBillByInvoicveNo(event.target.value);
    } else if (fieldName === "PaymentDate") {
      // console.log(event.target.value, fieldName);
      setPaymentDate(event.target.value);
      setShowPaymentDateError(event.target.value != "" ? false : true);
    } else if (fieldName === "PaymentMethod") {
      // console.log(event.value, fieldName, "PaymentMethod");
      setPaymentQuickbookId(
        event?.paymentquickbookid === undefined ? 0 : event?.paymentquickbookid
      );
      setPaymentMethodId(event?.value === undefined ? 0 : event?.value);
      setShowPaymentMethodError(event?.value === undefined ? true : false);
      // const { value } = event.value;
      // setSupplierInvoiceData((prevData) => {
      //   const newData = [...prevData];
      //   newData[index] = {
      //     ...newData[index],
      //     [fieldName]: event.value,
      //     ["isChecked"]: true,
      //   };
      //   return newData;
      // });
      // setFormValues((prevValues) => ({
      //   ...prevValues,
      //   [fieldName]: event.value,
      //   ["isChecked"]: true,
      // }));
    } else if (fieldName === "ReferenceNumber") {
      // console.log(event.target.value, fieldName);
      setReferenceNumber(event.target.value);
      setShowReferenceNumberError(event.target.value !== "" ? false : true);
    } else if (fieldName === "DepositTo") {
      setDepositToAccountQuickbookId(
        event?.DepositQuickbookId === undefined ? 0 : event?.DepositQuickbookId
      );
      setDepositTo(event?.value === undefined ? 0 : event?.value);
      setShowDepositToError(event?.value !== undefined ? false : true);
    } else if (fieldName === "AmountReceived") {
      // console.log(event.target.value, fieldName, "558");
      // console.log(paymentTotal - event.target.value, "total credit amount");
      // setCreditSubValue(Math.abs(paymentTotal - event.target.value))

      // setTotalReceivingAmount(event?.target?.value ? event?.target?.value : 0);

      setTotalReceivingAmountInput(
        event?.target?.value ? event?.target?.value : 0
      );

      setShowAmountReceivedError(event?.target?.value < 0 ? true : false);

      // To distribute total amount
      let enteredAmount = Number(event.target.value);
      let remainingAmount = enteredAmount;

      const updatedInvoices = supplierInvoiceData.map((invoice) => {
        if (remainingAmount > 0) {
          const allocatedAmount = Math.min(
            invoice.OpenBalance,
            remainingAmount
          );
          remainingAmount -= allocatedAmount;
          return {
            ...invoice,
            Payment: parseFloat(allocatedAmount).toFixed(2),
            isChecked: true,
          }; // Auto-check when allocated
        }
        return { ...invoice, Payment: 0, isChecked: false }; // Uncheck if no allocation
      });

      setSupplierInvoiceData(updatedInvoices);

      // console.log(
      //   Number(event.target.value == "" ? 0 : event.target.value),
      //   "556"
      // );
      // setAmountReceived(
      //   Number(event.target.value == "" ? 0 : event.target.value)
      // );
      // if (event.target.value > 0) {
      //   // setShowError({...showError, amountReceived: false})
      //   setShowAmountReceivedError(false);
      // } else {
      //   setShowAmountReceivedError(true);
      //   // setShowError({...showError, amountReceived: true})
      // }
    } else if (fieldName === "Memo") {
      // console.log(event.target.value, fieldName);
      // setFormValues((prevValues) => ({
      //   ...prevValues,
      //   [fieldName]: event.target.value,
      // }));
      setMemoData(event.target.value);
    } else if (fieldName === "PrintLater") {
      setPrintLater(printLater ? false : true);
    }
    // else if (fieldName === "CreditAppiedValue") {
    //   console.log(
    //     event.target.value,
    //     fieldName,
    //     supplierInvoiceData[index].Openingbalance,
    //     "145254"
    //   );
    //   if (
    //     Number(event.target.value) <=
    //     Number(supplierInvoiceData[index].Openingbalance)
    //   ) {
    //     setFormValues((prevValues) => ({
    //       ...prevValues,
    //       [fieldName]: Number(event.target.value),
    //       ["isChecked"]: true,
    //     }));

    //     const { value } = event.target;
    //     console.log(value, "value===>");
    //     // let TotalBal = supplierInvoiceData[index].CreditApplied;

    //     setSupplierInvoiceData((prevData) => {
    //       const newData = [...prevData];

    //       newData[index] = {
    //         ...newData[index],
    //         [fieldName]: value == "" ? "" : Number(value),
    //         ["isChecked"]: true,
    //         ["Payment"]:
    //           parseFloat(newData[index].Openingbalance) -
    //           // (Number(value)),
    //           (value == "" ? "" : Number(value)),
    //       };
    //       return newData;
    //     });
    //     setPaymentValue(
    //       supplierInvoiceData[index]?.Openingbalance - Number(value)
    //     );
    //     //toastWarn("Invalid Credit Applied Add More Fund");
    //   }
    // }   else {
    //   console.log("No Condition");
    // }
  };

  const handleDateChange = (newDate) => {
    setPaymentDate(newDate);
    setShowPaymentDateError(newDate != "" ? false : true);
  };

  // const handleHeaderCheckboxChange = (event) => {
  //   const isChecked = event.target.checked;
  //   if (isChecked) {
  //     // Check all checkboxes
  //     const updatedCheckedItems = supplierInvoiceData.map((item) => ({
  //       ...item,
  //       isChecked: true,
  //       Payment: item?.OpenBalance,
  //     }));
  //     // setCheckedItems(updatedCheckedItems);
  //     setSupplierInvoiceData(updatedCheckedItems);
  //   } else {
  //     // Uncheck all checkboxes
  //     // setCheckedItems([]);
  //     const updatedSupplierInvoiceData = supplierInvoiceData.map((item) => ({
  //       ...item,
  //       // Payment: 0,
  //       // CreditAppiedValue: 0,
  //       isChecked: false,
  //       Payment: 0,
  //     }));
  //     setSupplierInvoiceData(updatedSupplierInvoiceData);
  //     // setCheckedItems([]);
  //   }
  // };

  const handleHeaderCheckboxChange = (event) => {
    const isChecked = event.target.checked;

    // Update invoice data based on the header checkbox state
    const updatedInvoiceData = supplierInvoiceData.map((item) => ({
      ...item,
      isChecked,
      Payment: isChecked ? item?.OpenBalance : 0,
    }));
    setSupplierInvoiceData(updatedInvoiceData);

    if(enableAutoSuggestCreditBillPayment){
      // Calculate the total invoice payments if checked
      const invoiceTotalSum = isChecked
        ? updatedInvoiceData.reduce((acc, curr) => acc + Number(curr.Payment), 0)
        : 0;
  
      // Adjust the credit data based on the total invoice payments
      const updatedCreditData = supplierCreditData.map((item) => ({
        ...item,
        isChecked: false,
        Payment: 0,
      }));
  
      if (isChecked) {
        let remainingAmount = invoiceTotalSum;
  
        for (let i = 0; i < updatedCreditData.length; i++) {
          if (remainingAmount <= 0) break;
  
          if (remainingAmount >= updatedCreditData[i].OpenBalance) {
            updatedCreditData[i].isChecked = updatedCreditData[i].Type == 'Expense'? false : true;
            updatedCreditData[i].Payment = updatedCreditData[i].Type == 'Expense'? 0 : updatedCreditData[i].OpenBalance;
            remainingAmount -= updatedCreditData[i].OpenBalance;
          } else {
            updatedCreditData[i].isChecked = updatedCreditData[i].Type == 'Expense'? false : true;
            updatedCreditData[i].Payment = updatedCreditData[i].Type == 'Expense'? 0 : remainingAmount;
            remainingAmount = 0;
          }
        }
      }
  
      setSupplierCreditData(updatedCreditData);
    }
  };

  // const handleCheckboxChange = (event, index, itemRowData) => {
  //   if (event.target.checked) {
  //     const updatedDataNew = [...supplierInvoiceData];
  //     updatedDataNew[index] = {
  //       ...updatedDataNew[index],
  //       isChecked: true,
  //       Payment: updatedDataNew[index]?.OpenBalance,
  //     };
  //     setSupplierInvoiceData(updatedDataNew);
  //   } else {
  //     const updatedDataNew = [...supplierInvoiceData];
  //     updatedDataNew[index] = {
  //       ...updatedDataNew[index],
  //       isChecked: false,
  //       Payment: 0,
  //     };
  //     setSupplierInvoiceData(updatedDataNew);
  //   }
  // };

  const handleCheckboxChange = (event, index) => {
    // Update the invoice data based on the individual checkbox state
    const updatedInvoiceData = [...supplierInvoiceData];
    const selectedInvoice = { ...updatedInvoiceData[index] };
    selectedInvoice.isChecked = event.target.checked;
    selectedInvoice.Payment = event.target.checked
      ? selectedInvoice.OpenBalance
      : 0;
    updatedInvoiceData[index] = selectedInvoice;
    setSupplierInvoiceData(updatedInvoiceData);

    if(enableAutoSuggestCreditBillPayment){
      // Recalculate the total invoice payments
      const invoiceTotalSum = updatedInvoiceData
        ?.filter((el) => el?.isChecked)
        ?.reduce((acc, curr) => acc + Number(curr.Payment), 0);

      // Adjust the credit data based on the total invoice payments
      const updatedCreditData = supplierCreditData.map((item) => ({
        ...item,
        isChecked: false,
        Payment: 0,
      }));

      let remainingAmount = invoiceTotalSum;

      for (let i = 0; i < updatedCreditData.length; i++) {
        if (remainingAmount <= 0) break;

        if (remainingAmount >= updatedCreditData[i].OpenBalance) {
          updatedCreditData[i].isChecked = true;
          updatedCreditData[i].Payment = updatedCreditData[i].OpenBalance;
          remainingAmount -= updatedCreditData[i].OpenBalance;
        } else {
          updatedCreditData[i].isChecked = true;
          updatedCreditData[i].Payment = remainingAmount;
          remainingAmount = 0;
        }
      }

      setSupplierCreditData(updatedCreditData);
    }
  };

  const handleHeaderCheckboxChangeCredit = (event) => {
    const isChecked = event.target.checked;

    // Calculate the total sum of checked invoice payments
    const invoiceTotalSum = supplierInvoiceData
      ?.filter((el) => el?.isChecked)
      ?.reduce((acc, curr) => acc + Number(curr.Payment), 0);

    if (isChecked) {
      // Check all checkboxes and calculate the total sum of the credits
      const updatedCheckedItems = supplierCreditData.map((item) => ({
        ...item,
        isChecked: item.Type == 'Expense'? false : true ,
        Payment: item.Type == 'Expense'? 0 :item?.OpenBalance,
      }));

      const creditTotalSum = updatedCheckedItems
        ?.filter((el) => el?.isChecked)
        ?.reduce((acc, curr) => acc + Number(curr.Payment), 0);

      const diff = invoiceTotalSum - creditTotalSum;

      if (diff >= 0) {
        setSupplierCreditData(updatedCheckedItems);
      } else {
        // If the total credit exceeds the invoice payments, adjust the credit values
        let remainingAmount = invoiceTotalSum;
        const adjustedCheckedItems = updatedCheckedItems.map((item) => {
          if (remainingAmount <= 0) {
            return {
              ...item,
              isChecked: false,
              Payment: 0,
            };
          }

          if (remainingAmount >= item.OpenBalance) {
            remainingAmount -= item.OpenBalance;
            return {
              ...item,
              isChecked: item.Type == 'Expense'? false : true ,
              Payment:  item.Type == 'Expense'? 0 : item.OpenBalance,
            };
          } else {
            const payment = remainingAmount;
            remainingAmount = 0;
            return {
              ...item,
              isChecked: item.Type == 'Expense'? false : true ,
              Payment:  item.Type == 'Expense'? 0 : payment,
            };
          }
        });

        setSupplierCreditData(adjustedCheckedItems);
        toastWarn("Credit adjusted as it exceeded the invoice payments.");
      }
    } else {
      // Uncheck all checkboxes and reset payments
      const updatedUncheckedItems = supplierCreditData.map((item) => ({
        ...item,
        isChecked: false,
        Payment: 0,
      }));

      setSupplierCreditData(updatedUncheckedItems);
    }
  };

  const handleCheckboxChangeCredit = (event, index) => {
    const isChecked = event.target.checked;

    // Calculate the total sum of checked invoice payments
    const invoiceTotalSum = supplierInvoiceData
      ?.filter((el) => el?.isChecked)
      ?.reduce((acc, curr) => acc + Number(curr.Payment), 0);

    // Make a copy of the current credit data
    let updatedData = [...supplierCreditData];

    // Calculate the total sum of currently checked credit payments
    const currentCreditTotalSum = updatedData
      ?.filter((el) => el?.isChecked)
      ?.reduce((acc, curr) => acc + Number(curr.Payment), 0);

    // Calculate the remaining invoice amount that can be applied to credit
    const remainingInvoiceAmount = invoiceTotalSum - currentCreditTotalSum;

    if (isChecked && remainingInvoiceAmount <= 0) {
      // If there's no remaining invoice amount, show a warning and return
      toastWarn("Cannot update credit, Invoice amount is fully applied.");
      return;
    }

    // Tentatively update the credit data based on the checkbox state
    updatedData[index] = {
      ...updatedData[index],
      isChecked: isChecked,
      Payment: isChecked
        ? Math.min(
            Number(updatedData[index]?.OpenBalance),
            remainingInvoiceAmount
          )
        : 0,
    };

    // Calculate the new total sum of checked credit payments after the tentative update
    const newCreditTotalSum = updatedData
      ?.filter((el) => el?.isChecked)
      ?.reduce((acc, curr) => acc + Number(curr.Payment), 0);

    // Check if the total credit is less than or equal to the invoice total
    const diff = Number(invoiceTotalSum) - Number(newCreditTotalSum);

    if (diff >= 0) {
      setSupplierCreditData(updatedData);
    } else {
      toastWarn(
        "Cannot update credit, Credit is not more than Invoice Payment"
      );
    }
  };

  // const handlePayment = (event, index) => {
  //   console.log(event.target.value, "payment input");
  //   const checkedItemsCopy = [...supplierInvoiceData];
  //   const selectedInvoice = checkedItemsCopy[index];
  //   selectedInvoice.Payment = event.target.value;
  //   selectedInvoice.isChecked = true;
  //   checkedItemsCopy[index] = selectedInvoice;
  //   setSupplierInvoiceData(checkedItemsCopy);
  // };

  // const handlePayment = (event, index) => {
  //   console.log(event.target.value, "payment input");

  //   // Update the payment value and set the invoice as checked
  //   const updatedInvoiceData = [...supplierInvoiceData];
  //   const selectedInvoice = { ...updatedInvoiceData[index] };
  //   selectedInvoice.Payment = Number(event.target.value);
  //   selectedInvoice.isChecked = true;
  //   updatedInvoiceData[index] = selectedInvoice;
  //   setSupplierInvoiceData(updatedInvoiceData);

  //   // Recalculate the total invoice payments
  //   const invoiceTotalSum = updatedInvoiceData
  //     ?.filter((el) => el?.isChecked)
  //     ?.reduce((acc, curr) => acc + Number(curr.Payment), 0);

  //   // Uncheck all credits initially
  //   const updatedCreditData = supplierCreditData.map((item) => ({
  //     ...item,
  //     isChecked: false,
  //     Payment: 0,
  //   }));

  //   // Apply credits sequentially
  //   let remainingAmount = invoiceTotalSum;
  //   for (let i = 0; i < updatedCreditData.length; i++) {
  //     if (remainingAmount <= 0) break;

  //     if (remainingAmount >= updatedCreditData[i].OpenBalance) {
  //       updatedCreditData[i].isChecked = true;
  //       updatedCreditData[i].Payment = updatedCreditData[i].OpenBalance;
  //       remainingAmount -= updatedCreditData[i].OpenBalance;
  //     } else {
  //       updatedCreditData[i].isChecked = true;
  //       updatedCreditData[i].Payment = remainingAmount;
  //       remainingAmount = 0;
  //     }
  //   }

  //   setSupplierCreditData(updatedCreditData);
  // };

  const handlePayment = (event, index) => {
    console.log(event.target.value, "payment input");

    const inputValue = event.target.value;
    // const inputValue = Number(event.target.value);

    // Update the payment value and set the invoice as checked if the value is greater than 0
    const updatedInvoiceData = [...supplierInvoiceData];
    const selectedInvoice = { ...updatedInvoiceData[index] };
    selectedInvoice.Payment = inputValue;
    selectedInvoice.isChecked = inputValue > 0;
    updatedInvoiceData[index] = selectedInvoice;
    setSupplierInvoiceData(updatedInvoiceData);

    if(enableAutoSuggestCreditBillPayment){
      // Recalculate the total invoice payments
      const invoiceTotalSum = updatedInvoiceData
        ?.filter((el) => el?.isChecked)
        ?.reduce((acc, curr) => acc + Number(curr.Payment), 0);

      // Uncheck all credits initially
      const updatedCreditData = supplierCreditData.map((item) => ({
        ...item,
        isChecked: false,
        Payment: 0,
      }));

      // Apply credits sequentially if the invoice total sum is greater than 0
      if (invoiceTotalSum > 0) {
        let remainingAmount = invoiceTotalSum;
        for (let i = 0; i < updatedCreditData.length; i++) {
          if (remainingAmount <= 0) break;

          if (remainingAmount >= updatedCreditData[i].OpenBalance) {
            updatedCreditData[i].isChecked = true;
            updatedCreditData[i].Payment = updatedCreditData[i].OpenBalance;
            remainingAmount -= updatedCreditData[i].OpenBalance;
          } else {
            updatedCreditData[i].isChecked = true;
            updatedCreditData[i].Payment = parseFloat(remainingAmount).toFixed(2);
            remainingAmount = 0;
          }
        }
      }

      setSupplierCreditData(updatedCreditData);
    }
  };

  // const handlePaymentCredit = (event, index) => {
  //   const invoiceTotalSum = supplierInvoiceData
  //     ?.filter((el) => el?.isChecked)
  //     ?.reduce((acc, curr) => acc + Number(curr.Payment), 0);

  //   const checkedItemsCopy = [...supplierCreditData];
  //   const selectedInvoice = checkedItemsCopy[index];
  //   selectedInvoice.isChecked = event.target.value ? true : false;
  //   selectedInvoice.Payment = event.target.value;
  //   checkedItemsCopy[index] = selectedInvoice;

  //   const creditTotalSum = checkedItemsCopy
  //     ?.filter((el) => el?.isChecked)
  //     ?.reduce((acc, curr) => acc + Number(curr.Payment), 0);

  //   const diff = invoiceTotalSum - creditTotalSum;
  //   if (diff >= 0) {
  //     setSupplierCreditData(checkedItemsCopy);
  //   } else {
  //     toastWarn(
  //       "Cannot update credit, Credit is not more then Invoice Payment"
  //     );
  //   }
  // };

  const handlePaymentCredit = (event, index) => {
    const invoiceTotalSum = supplierInvoiceData
      ?.filter((el) => el?.isChecked)
      ?.reduce((acc, curr) => acc + Number(curr.Payment), 0);

    const checkedItemsCopy = [...supplierCreditData];
    const selectedCredit = checkedItemsCopy[index];
    selectedCredit.isChecked = event.target.value > 0 ? true : false;
    selectedCredit.Payment = Number(event.target.value);
    checkedItemsCopy[index] = selectedCredit;

    const creditTotalSum = checkedItemsCopy
      ?.filter((el) => el?.isChecked)
      ?.reduce((acc, curr) => acc + Number(curr.Payment), 0);

    const diff = invoiceTotalSum - creditTotalSum;

    if (diff >= 0) {
      setSupplierCreditData(checkedItemsCopy);
    } else {
      // If the input exceeds the total invoice payments, adjust the value automatically
      selectedCredit.Payment += diff;
      selectedCredit.isChecked = selectedCredit.Payment > 0;
      checkedItemsCopy[index] = selectedCredit;

      setSupplierCreditData(checkedItemsCopy);

      toastWarn("Credit adjusted as it exceeded the invoice payments.");
    }
  };

  const validatePaymentDetails = ({
    paymentDate,
    paymentMethodId,
    referenceNumber,
    depositTo,
    totalReceivingAmount,
    setShowPaymentDateError,
    setShowPaymentMethodError,
    setShowReferenceNumberError,
    setShowDepositToError,
    setShowAmountReceivedError,
    invoiceTotalSum,
    creditTotalSum,
  }) => {
    let hasError = false;

    if (paymentDate === "") {
      setShowPaymentDateError(true);
      hasError = true;
    } else {
      setShowPaymentDateError(false);
    }

    if (paymentMethodId < 1) {
      setShowPaymentMethodError(true);
      hasError = true;
    } else {
      setShowPaymentMethodError(false);
    }

    if (referenceNumber === "") {
      setShowReferenceNumberError(true);
      hasError = true;
    } else {
      setShowReferenceNumberError(false);
    }

    if (depositTo < 1) {
      setShowDepositToError(true);
      hasError = true;
    } else {
      setShowDepositToError(false);
    }

    if (
      (totalReceivingAmountInput == 0
        ? totalReceivingAmount
        : totalReceivingAmountInput) < 0
    ) {
      setShowAmountReceivedError(true);
      hasError = true;
    } else {
      setShowAmountReceivedError(false);
    } // 100   -   50    = 50

    // if (((invoiceTotalSum - creditTotalSum)  === 0) && (invoiceTotalSum - creditTotalSum) === totalReceivingAmount ) {
    // }else{
    //   toastWarn("The Amount Received (plus credits) can't be less than the selected charges. Also, the selected charges can't be less than the selected credits.")
    //   hasError = true;
    // }

    if (
      (totalReceivingAmountInput == 0
        ? totalReceivingAmount
        : totalReceivingAmountInput) -
        (invoiceTotalSum - creditTotalSum) <
      0
    ) {
      toastWarn(
        "The Amount Received (plus credits) can't be less than the selected charges. Also, the selected charges can't be less than the selected credits."
      );
      hasError = true;
    }

    return !hasError;
  };

  const SubmitReceivePayment = (field) => {

    const receivedAmount = Number(totalReceivingAmountInput || totalReceivingAmount);
    const anyInvoiceSelected = supplierInvoiceData?.some((item) => item?.isChecked);

    if (receivedAmount <= 0 && !anyInvoiceSelected) {
      toastWarn("You need to add an amount greater than 0 to Pay this payment..");
      return;
    }

    const invoiceTotalSum = supplierInvoiceData
      ?.filter((el) => el?.isChecked)
      ?.reduce((acc, curr) => acc + Number(curr.Payment), 0);

    const creditTotalSum = supplierCreditData
      ?.filter((el) => el?.isChecked)
      ?.reduce((acc, curr) => acc + Number(curr.Payment), 0);

    const isValid = validatePaymentDetails({
      paymentDate,
      paymentMethodId,
      referenceNumber,
      depositTo,
      totalReceivingAmount,
      setShowPaymentDateError,
      setShowPaymentMethodError,
      setShowReferenceNumberError,
      setShowDepositToError,
      setShowAmountReceivedError,
      invoiceTotalSum,
      creditTotalSum,
    });

    if (!isValid) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const listOfInvoiceCredit = [...supplierInvoiceData, ...supplierCreditData];
    console.log(listOfInvoiceCredit, "listOfInvoiceCredit");

    const updatedData = listOfInvoiceCredit.map((item) => {
      if (item?.IsJournalEntry == 1) {
        item.Type = "JournalEntry";
      }
      return item;
    });

    // return;

    const workOrderItemobj = {};
    workOrderItemobj.XMLBill = updatedData?.filter((el) => el?.isChecked);
    let workorderitemjsonstring = JSON.stringify(workOrderItemobj);

    const data = {
      TransactionId: paramObject.id == undefined ? 0 : paramObject.id,
      InvoiceXml: workorderitemjsonstring,
      SupplierId: supplierId,
      PaymentDate: paymentDate,
      PaymentMethod: paymentMethodId,
      DepositTo: depositTo,
      Memo: memoData,
      RefNo: referenceNumber,
      AttechMents: attachmentUrl,
      AmountReceived:
        totalReceivingAmountInput == 0
          ? totalReceivingAmount
          : totalReceivingAmountInput,
      LogninUser: Number(Id),
      QuickBookId: TxnQuickbookid,
      LocationId: Number(locationId),

      SupplierQuickBookId: supplierQuickBookId,
      PaymentQuickbookId: paymentQuickbookId,
      DepositToAccountQuickbookId: depositToAccountQuickbookId,
      printstatus: printLater ? 1 : 0,
    };

    console.log(field, "fieldfield");
    setduleddata(field);
    setreceivedata(data);

    if (handleOpenRef.current) {
      handleOpenRef.current();
    }
    console.log(handleOpenRef, "1114");

    // return;

    // setLoading(true);
    // axios
    //   .post(
    //     `${config.receivingBaseUrl}/receivings/receivingpaybillupsert_V2`,
    //     data,
    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         "Access-Control-Allow-Origin": "*",
    //         Authorization: token,
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     if (res.data.ResponseCode === "SUCCESS") {
    //       toastSuccess(SUCCESS_MESSAGE);

    //       if (paramObject.id > 0 && field == "saveandclose") {
    //         navigate("/transaction-log");
    //       } else if (field == "saveandclose" && paramObject.id == undefined) {
    //         navigate("/receiving");
    //       } else {
    //         navigate("/receiving-paybills");
    //         // window.location.reload();
    //         // setSupplierQuickBookId(0);
    //         // setSupplierName("");
    //         // setSupplierId(supplierId);
    //         setSupplierCreditData([]);
    //         setSupplierInvoiceData([]);
    //         setFindBillByInvoicveNo(0);
    //         setPaymentDate(moment().format("YYYY-MM-DD"));
    //         setPaymentMethodId(0);
    //         setPaymentQuickbookId(0);
    //         setReferenceNumber("");
    //         setDepositTo(0);
    //         setDepositToAccountQuickbookId(0);
    //         setMemoData("");
    //         setAttachmentUrl("");
    //         setTotalReceivingAmount(0);

    //         ParticularSupplierInvoiceAPI(supplierId, 0, locationId, "new")
    //         // setSelectedSupplierTotalBalance(0);
    //       }
    //     } else if (
    //       res.data.ResponseCode === "ERROR" &&
    //       res.data.ResponseID < 0
    //     ) {
    //       toastError(ERROR_MESSAGE);
    //     } else {
    //       toastError(ERROR_MESSAGE);
    //     }
    //     setLoading(false);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     setLoading(false);
    //   });
  };

  useEffect(() => {
    let InvoiceTotalSum = supplierInvoiceData
      ?.filter((el) => el?.isChecked)
      ?.reduce(
        (accumulator, currentValue) =>
          accumulator + Number(currentValue?.Payment),
        0
      );
    let CreditTotalSum = supplierCreditData
      ?.filter((el) => el?.isChecked)
      ?.reduce(
        (accumulator, currentValue) =>
          accumulator + Number(currentValue?.Payment),
        0
      );

    console.log(
      InvoiceTotalSum,
      CreditTotalSum,
      InvoiceTotalSum - CreditTotalSum,
      "receiving amount"
    );
    setTotalReceivingInvoiceAmount(InvoiceTotalSum);
    setTotalReceivingCreditAmount(CreditTotalSum);
    let amount =
      InvoiceTotalSum - CreditTotalSum > 0
        ? parseFloat(InvoiceTotalSum - CreditTotalSum).toFixed(2)
        : InvoiceTotalSum - CreditTotalSum;

    setTotalReceivingAmount(amount);

    setShowAmountReceivedError(
      Number(InvoiceTotalSum - CreditTotalSum) < 0 ? true : false
    );
  }, [supplierInvoiceData, supplierCreditData]);

  console.log(
    "Supplier:",
    supplierId,
    "|| SupplierQuickbook:",
    supplierQuickBookId,
    "|| referenceNumber:",
    referenceNumber,
    "|| PaymentDate:",
    paymentDate,
    "|| DepositTo:",
    depositTo,
    "|| depositToQuickbookID:",
    depositToAccountQuickbookId,
    "|| PaymentMethod:",
    paymentMethodId,
    "|| PaymentMethodQuickbookID:",
    paymentQuickbookId,
    "|| findBillByInvoicveNo:",
    findBillByInvoicveNo,
    "|| memoData:",
    memoData,
    "|| ===> 20062024Ashi"
  );
  console.log(supplierInvoiceData, "gddjh");

  const handleDeletePopup = () => {
    const deleteRequestParam = {
      id: paramObject.id,
      quickbookid: TxnQuickbookid,
      Transferquickbookid: TxnQuickbookid,
      Deposit: 0,
      Payment:
        totalReceivingAmountInput == 0
          ? totalReceivingAmount
          : totalReceivingAmountInput,
      rootquickbookid: 0,
      TransactionTypeID: 7,
      loginuserid: Number(Id),
      transactiontype: 7,
      module: "PAYBILLS",
      notlistingdata: [],
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setDeleteModalOpen(true);
  };
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Sales</h3> */}
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/receiving">Receiving List</Link>
                </li>
                <li className="breadcrumb-item active">Pay Bill</li>
              </ul>
            </div>
          </div>
          {/* Pay Bill Card */}
          <div className="card">
            <div className="card-body">
              {!QBpermission && AllowQBSync && (
                <QuickbookSyncMessageComponent type="Pay Bills" />
              )}
              <button
                className="btn btn-sm pt-0 "
                type="button"
                data-bs-target="#RecentTransactionsModal"
                data-bs-toggle="modal"
              >
                <i class="fa fa-history fs-4"></i>
              </button>
              <span className="p-lg">{"Bill Payment"}</span>
              {/* First Row */}
              <div className="d-flex flex-row col-md-12 mt-2">
                {/* Supplier */}
                <div className="ml-2 col-md-4">
                  <Select
                    options={supplier}
                    placeholder="Select Supplier"
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    id="Supplier"
                    name="Supplier"
                    onChange={(event) => handleChangeInput(event, "Supplier")}
                    value={supplier?.find((option) => {
                      return option.value === supplierId;
                    })}
                    // isDisabled={paramObject?.id > 0 ? true : false}
                    className="custom-search-select"
                  />
                  {/* {showAccountSelectError && (
                    <p className="text-danger mb-0">
                      * Supplier field is required
                    </p>
                  )} */}
                </div>
                {/* InvoiceNumber */}
                {false ? (
                  <>
                    <div className="ml-2 col-md-2">
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Find by invoice no."
                        name="InvoiceNumber"
                        onChange={(event) =>
                          handleChangeInput(event, "InvoiceNumber")
                        }
                      ></input>
                      {showInvoiceNotFound && (
                        <div className="mt-1">
                          {/* <i class='fa-solid fa-triangle-exclamation' style={{color: 'red'}}></i> */}
                          <i
                            className="fa fa-info-circle fs-5 mt-1 mr-1"
                            style={{ color: "var(--secondary-main-color)" }}
                          ></i>
                          Bill not found
                        </div>
                      )}
                    </div>
                    {/* Find */}
                    <div className="ml-2 col-md-2">
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={handleFindData}
                        name="Find"
                      >
                        Find Data
                      </button>
                      <div className="mt-1">
                        Don't have an invoice?{" "}
                        <Link
                          to={
                            isManageSale == 1
                              ? "/manage-receiving"
                              : isManagePOSSale == 1
                              ? "/pos-receiving"
                              : "#"
                          }
                          // to="/manage-receiving"
                        >
                          Create a new Receive
                        </Link>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="ml-2 col-md-2"></div>
                    <div className="ml-2 col-md-2"></div>
                  </>
                )}
                {/* Amount Received Display */}
                {/* <div className="col-md-2"></div> */}
                <div className="ml-2 col-md-2 pull-left">
                  <p className="p-medium">Amount Recevied:</p>
                  {/* <h3 className="fw-bolder">${amountReceived}</h3> */}
                  <p className="p">
                    {/* ${parseFloat(totalReceivingAmount).toFixed(2)} */}
                    {/* {parseFloat(
                      totalReceivingAmountInput == 0
                        ? totalReceivingAmount
                        : totalReceivingAmountInput
                    ).toFixed(2)} */}
                    {CurrencySymbols(
                      Number(
                        totalReceivingAmountInput == 0
                          ? totalReceivingAmount
                          : totalReceivingAmountInput
                      ),
                      CurrencySymbol,
                      FractionDigits
                    )}
                  </p>
                  <p className="bold">Supplier balance</p>
                  <p className="bold">
                    {showSupplierBalance ? CurrencySymbols(
                      Number(supplierOpenBalance),
                      CurrencySymbol,
                      FractionDigits
                    ): (<span style={{ fontSize: "12px", cursor:'pointer', textDecoration: "underline" }} onClick={()=> checkBalance()}>
                        Click Here
                      </span>)}
                  </p>
                </div>
              </div>

              {/* Error Row */}
              {showOpenInvoiceError && (
                <div
                  className="d-flex flex-row col-md-12 mt-2 mb-2"
                  style={{ border: "1px solid var(--secondary-main-color)" }}
                >
                  <i
                    className="fa fa-info-circle fs-3 p-2 mr-2"
                    style={{ color: "var(--secondary-main-color)" }}
                  ></i>
                  <div>
                    <p className="bold">
                      {supplierName}’s payment doesn’t have an open invoice to
                      go with it
                    </p>
                    <p>
                      We’ll save this payment as credit to your supplier since
                      you don’t have any open invoices. If you want to record
                      this payment without an invoice,{" "}
                      {/* <Link to="/manage-sales">create a sales receipt </Link> */}
                      <Link
                        to={
                          isManageSale == 1
                            ? "/manage-sales"
                            : isManagePOSSale == 1
                            ? "/pos"
                            : "#"
                        }
                      >
                        Create a Sales Receipt
                      </Link>
                    </p>
                  </div>
                </div>
              )}

              {/* Second Row */}
              <div className="d-flex flex-row col-md-12">
                {/* Payment Date */}
                <div className="ml-2 col-md-2">
                  <div className=" col-form-label">Payment Date:</div>
                  <CommonDatePicker
                    FinalDate={
                      paymentDate === "Invalid date" ? "" : paymentDate
                    }
                    handleDateChange={handleDateChange}
                  />
                  {showPaymentDateError && (
                    <p className="text-danger mb-0">
                      * Payment Date is required
                    </p>
                  )}
                </div>
                {
                  // Number(paramObject?.id) > 0 &&
                  selectedPaymentType == "Check" && (
                    <div className="col-md-2 ms-5">
                      <div className=" col-form-label">Print Later</div>
                      <input
                        type="checkbox"
                        checked={printLater}
                        style={{ transform: "scale(1.2)", margin: "5px" }}
                        onChange={(event) =>
                          handleChangeInput(event, "PrintLater")
                        }
                      />
                    </div>
                  )
                }
              </div>

              {/* Third Row */}
              <div className="d-flex flex-row col-md-12">
                {/* Payment Method */}
                <div className="p-2 col-md-2">
                  <div className=" col-form-label">Payment Method:</div>
                  <Select
                    options={paymentMethod}
                    placeholder="Select Method"
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    id="PaymentMethod"
                    name="PaymentMethod"
                    // isClearable={true}
                    onChange={(event) =>
                      handleChangeInput(event, "PaymentMethod")
                    }
                    value={paymentMethod?.find((option) => {
                      return option.value === paymentMethodId;
                    })}
                    className="custom-search-select"
                  />
                  {showPaymentMethodError && (
                    <p className="text-danger mb-0">
                      * Payment Method is required
                    </p>
                  )}
                </div>
                {/* Reference Number */}
                <div className="p-2 col-md-2">
                  <div className=" col-form-label">Reference Number:</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Reference No."
                    name="ReferenceNumber"
                    id="ReferenceNumber"
                    onChange={(event) =>
                      handleChangeInput(event, "ReferenceNumber")
                    }
                    value={printLater ? "To Print" : referenceNumber} //selectedPaymentType == "Check" &&
                  />
                  {showReferenceNumberError && (
                    <p className="text-danger mb-0">
                      * Reference Number is required
                    </p>
                  )}
                </div>
                {/* Deposit To */}
                <div className="p-2 col-md-4">
                  <div className=" col-form-label">Bank/Credit account: </div>
                  <Select
                    options={depositToAccount}
                    placeholder="Select a Account"
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    id="DepositTo"
                    name="DepositTo"
                    onChange={(event) => handleChangeInput(event, "DepositTo")}
                    value={depositToAccount?.find((option) => {
                      return option.value === depositTo;
                    })}
                    className="custom-search-select"
                    formatOptionLabel={({ label, parentName, AccountType }) => (
                      <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <span>{label}</span>
                        <span style={{ fontStyle: "italic", color: "#666", marginLeft: "1rem" }}>
                          {parentName ? `Sub-account of ${parentName}` : AccountType}
                        </span>
                      </div>
                    )}
                  />
                  {showDepositToError && (
                    <p className="text-danger mb-0">* Deposit is required</p>
                  )}
                </div>
                <div className="col-md-2 align-content-end pb-1">
                  {depositTo > 0 && (
                    <div className="col-form-label">
                      Balance:{" "}
                      {CurrencySymbols(
                        Number(
                          depositToAccount?.find((el) => el?.value == depositTo)
                            ?.Amount
                        ),
                        CurrencySymbol,
                        FractionDigits
                      )}
                    </div>
                  )}
                </div>
                {/* <div className="ml-2 col-md-2"></div> */}
                {/* Amount Received */}
                <div className="p-2 col-md-2">
                  <div className=" col-form-label">Amount Received:</div>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="AmountReceived"
                    id="AmountReceived"
                    // value={
                    //   totalReceivingAmountInput == 0
                    //     ? totalReceivingAmount
                    //     : totalReceivingAmountInput
                    // }
                    value={
                      totalReceivingAmountInput == 0
                        ? `${CurrencySymbol}${
                            totalReceivingAmount ? totalReceivingAmount : ""
                          }`
                        : `${CurrencySymbol}${totalReceivingAmountInput}`
                    }
                    onChange={(event) => {
                      let inputValue = event.target.value;

                      console.log(inputValue, "ggtt");
                      inputValue = inputValue.replace(/[^\d.]/g, "");

                      if (
                        inputValue &&
                        !inputValue.startsWith(CurrencySymbol)
                      ) {
                        inputValue = `${inputValue}`;
                      }

                      event.target.value = inputValue;
                      handleChangeInput(event, "AmountReceived");
                    }}
                    onFocus={(event) => event.target.select()}
                    min={0}
                    // readOnly
                  />
                  {showAmountReceivedError && (
                    <p className="text-danger mb-0">
                      * Amount Received is greater than or equal to 0
                    </p>
                  )}
                </div>
                {/* Amount Received Input */}
              </div>
            </div>
          </div>
          {/* Invoice List and Credit List */}
          {(supplierInvoiceData?.length > 0 ||
            supplierCreditData?.length > 0) && (
            // {true && (
            <div className="card">
              <div className="card-body">
                {supplierInvoiceData?.length > 0 && (
                  <div>
                    <p className="bold small-font-size p-2">
                      Outstanding Transactions
                    </p>
                    <div>
                      <table className="table">
                        <thead>
                          <tr>
                            <th>
                              <input
                                type="checkbox"
                                onChange={handleHeaderCheckboxChange}
                                checked={
                                  supplierInvoiceData.length ==
                                  supplierInvoiceData.filter(
                                    (el) => el.isChecked == true
                                  ).length
                                }
                              />
                            </th>
                            <th style={{ width: "500px" }}>DESCRIPTION</th>
                            <th>DUE DATE </th>
                            <th>ORIGINAL AMOUNT</th>
                            <th>OPEN BALANCE </th>
                            <th>PAYMENT</th>
                          </tr>
                        </thead>
                        <tbody>
                          {supplierInvoiceData?.map((u, index) => {
                            return (
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    onChange={(event) =>
                                      handleCheckboxChange(event, index, u)
                                    }
                                    // checked={checkedItems[index]?.ID === u.ID}
                                    // checked={isChecked}
                                    checked={
                                      supplierInvoiceData[index]?.isChecked
                                    }
                                    // checked={}
                                  ></input>
                                </td>
                                <td>
                                  <a
                                    href={
                                      u.Type === "Bill" && u.IsJournalEntry === 0
                                      ? `/receiving-receipt/${u.PosId}`
                                        : u.Type === "Expense"
                                        ? `/Expense/${u.ID}`
                                        : u.Type === "Deposit"
                                        ? `/bank-deposit/${u.ID}`
                                        : u.Type === "Bill" &&
                                          u.IsJournalEntry === 1
                                        ? `/journal-entry/${u.MainID}`
                                        : ""
                                    }
                                  >
                                    {u.Description}
                                    <p> {u.SupplierName}</p>
                                  </a>
                                </td>
                                <td>
                                  {u.DueDate
                                    ? moment(u.DueDate).format("MM/DD/YYYY")
                                    : ""}
                                </td>
                                <td>
                                  <span
                                  style={{
                                    display: "inline-block",
                                    width: "10px",
                                    height: "10px",
                                    borderRadius: "50%",
                                    backgroundColor: u.SyncStatus == 1 ? "green" : "red",
                                    marginRight: "8px",
                                  }}
                                  ></span>
                                  {CurrencySymbols(
                                    Number(u.OriginalAmount),
                                    CurrencySymbol,
                                    FractionDigits
                                  )}
                                </td>
                                <td>
                                  {CurrencySymbols(
                                    Number(u.OpenBalance),
                                    CurrencySymbol,
                                    FractionDigits
                                  )}
                                </td>
                                <td>
                                  <input
                                    style={{ width: "85%" }}
                                    type="text"
                                    className="form-control form-control-sm numberonly"
                                    name="Payment"
                                    value={`${CurrencySymbol} ${u?.Payment}`}
                                    // value={u?.Payment}
                                    // defaultValue={Number(u?.Payment).toFixed(2)}
                                    // defaultValue={Number(paymentValue).toFixed(2)}
                                    onChange={(event) => {
                                      if (
                                        Number(
                                          event?.target?.value
                                            .replace(`${CurrencySymbol}`, " ")
                                            .trim()
                                        ) <= Number(u?.OpenBalance)
                                      ) {
                                        let inputValue = event.target.value;

                                        console.log(inputValue, "ggtt");
                                        inputValue = inputValue.replace(
                                          /[^\d.]/g,
                                          ""
                                        );

                                        if (
                                          inputValue &&
                                          !inputValue.startsWith(CurrencySymbol)
                                        ) {
                                          inputValue = `${inputValue}`;
                                        }

                                        event.target.value = inputValue;
                                        handlePayment(event, index);
                                      } else {
                                        toastWarn(
                                          "invoice Amount is not more then Open Balance"
                                        );
                                      }
                                    }}
                                    max={Number(u.OpenBalance)}
                                    min={0}
                                    onFocus={(event) => event.target.select()}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                {supplierCreditData?.length > 0 && (
                  <div className="mt-8">
                    <p className="bold small-font-size p-2">Credits</p>
                    <div>
                      <table className="table ">
                        <thead>
                          <tr>
                            <th>
                              <input
                                type="checkbox"
                                onChange={handleHeaderCheckboxChangeCredit}
                                checked={
                                  supplierCreditData.length ==
                                  supplierCreditData.filter(
                                    (el) => el.isChecked == true
                                  ).length
                                }
                              />
                            </th>
                            <th style={{ width: "500px" }}>DESCRIPTION</th>
                            {/* <th>DUE DATE </th> */}
                            <th>ORIGINAL AMOUNT</th>
                            <th>OPEN BALANCE </th>
                            <th>PAYMENT</th>
                          </tr>
                        </thead>
                        <tbody>
                          {supplierCreditData?.map((u, index) => {
                            return (
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    onChange={(event) =>
                                      handleCheckboxChangeCredit(
                                        event,
                                        index,
                                        u
                                      )
                                    }
                                    // checked={checkedItems[index]?.ID === u.ID}
                                    // checked={isChecked}
                                    checked={
                                      supplierCreditData[index]?.isChecked
                                    }
                                    disabled={u?.Type == 'Expense'}
                                    // checked={}
                                  ></input>
                                </td>
                                <td>
                                  <a
                                    href={
                                      u.Type === "VendorCredit" && u.isCreditJournalEntry == 0
                                        // ? isManageSale == 1
                                        //   ? `/manage-sales/${u.ID}`
                                        //   : isManagePOSSale == 1
                                        //   ? `/pos/${u.ID}`
                                        //   : "#"
                                        ? `/receiving-receipt/${u.PosId}`
                                        : u.Type === "Deposit"
                                        ? `/bank-deposit/${u.ID}`
                                        : u.Type === "VendorCredit" &&
                                          u.isCreditJournalEntry == 1
                                        ? `/journal-entry/${u.MainID}`
                                        : u.Type === "unappliedpayment"
                                        ? `/receive-payment/${u.ID}`
                                        : ""
                                    }
                                  >
                                    {
                                      u.Description
                                      // + " | " +
                                      //   u.ID +
                                      //   " | " +
                                      //   u.SupplierName
                                    }
                                    <p> {u.SupplierName}</p>
                                  </a>
                                </td>
                                {/* <td>
                                  {moment(u.DueDate).format("MM/DD/YYYY ")}
                                </td> */}
                                <td>
                                  <span
                                  style={{
                                    display: "inline-block",
                                    width: "10px",
                                    height: "10px",
                                    borderRadius: "50%",
                                    backgroundColor: u.SyncStatus == 1 ? "green" : "red",
                                    marginRight: "8px",
                                  }}
                                  ></span>
                                  {CurrencySymbols(
                                    Number(u.OriginalAmount),
                                    CurrencySymbol,
                                    FractionDigits
                                  )}
                                </td>
                                <td>
                                  {CurrencySymbols(
                                    Number(u.OpenBalance),
                                    CurrencySymbol,
                                    FractionDigits
                                  )}
                                </td>
                                <td>
                                  <input
                                    style={{ width: "85%" }}
                                    type="text"
                                    className="form-control form-control-sm numberonly"
                                    name="Payment"
                                    // value={u?.Payment}
                                    value={`${CurrencySymbol} ${u?.Payment}`}
                                    onChange={(event) => {
                                      let inputValue = event.target.value;
                                      console.log(inputValue, "ggtt");
                                      if (
                                        Number(
                                          event?.target?.value
                                            .replace(`${CurrencySymbol}`, " ")
                                            .trim()
                                        ) <= Number(u?.OpenBalance)
                                      ) {
                                        let inputValue = event.target.value;

                                        console.log(inputValue, "ggtt");
                                        inputValue = inputValue.replace(
                                          /[^\d.]/g,
                                          ""
                                        );

                                        if (
                                          inputValue &&
                                          !inputValue.startsWith(CurrencySymbol)
                                        ) {
                                          inputValue = `${inputValue}`;
                                        }

                                        event.target.value = inputValue;
                                        handlePaymentCredit(event, index);
                                      } else {
                                        toastWarn(
                                          "Credit Amount is not more then Open Balance"
                                        );
                                      }
                                    }}
                                    max={Number(u.OpenBalance)}
                                    min={0}
                                    onFocus={(event) => event.target.select()}
                                    disabled={u?.Type == 'Expense'}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                <div className="p-2 mr-8 font-bold text-right d-flex justify-content-end mt-5">
                  <div className="d-flex gap-1">
                    <div>
                      <p className="fs-5">Amount to Apply: {"  "}</p>
                      <p className="fs-5">Amount to Credit: {"  "}</p>
                    </div>
                    <div>
                      {/* <p className="fs-5">
                        $
                        {Number(
                          totalReceivingAmountInput == 0
                            ? totalReceivingAmount
                            : totalReceivingAmountInput
                        ) + Number(totalReceivingCreditAmount)}
                      </p>
                      <p className="fs-5">
                        $
                        {Number(
                          totalReceivingAmountInput == 0
                            ? totalReceivingAmount
                            : totalReceivingAmountInput
                        ) +
                          totalReceivingCreditAmount -
                          totalReceivingInvoiceAmount}
                      </p> */}
                      <p className="fs-5">
                        {CurrencySymbols(
                          Number(
                            totalReceivingAmountInput == 0
                              ? totalReceivingAmount
                              : totalReceivingAmountInput
                          ) + Number(totalReceivingCreditAmount),
                          CurrencySymbol,
                          FractionDigits
                        )}
                      </p>
                      <p className="fs-5">
                        {CurrencySymbols(
                          Number(
                            totalReceivingAmountInput == 0
                              ? totalReceivingAmount
                              : totalReceivingAmountInput
                          ) +
                            totalReceivingCreditAmount -
                            totalReceivingInvoiceAmount,
                          CurrencySymbol,
                          FractionDigits
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Pay Bill Table Card */}
          <div className="card">
            <div className="card-body">
              <div className="d-flex flex-column-reverse mb-3">
                <div className="p-2 col-md-3">
                  <div className=" col-form-label">Memo:</div>
                  <textarea
                    className="form-control"
                    name="Memo"
                    placeholder="Note"
                    style={{ width: "410px", height: "150px" }}
                    onChange={(event) => handleChangeInput(event, "Memo")}
                    defaultValue={memoData}
                  ></textarea>
                </div>
                <div className="p-2 col-md-4">
                  <div className=" col-form-label">Attachment:</div>
                  <input
                    type="file"
                    className="form-control form-control-sm "
                    id="Attachment"
                    name="Attachment"
                    accept=".pdf,.jpg,.jpeg,.heic,.png"
                    // onChange={handleFileChange}
                    onChange={(e, i) =>
                      CommonHandleFileChange(e, i, setLoading, setAttachmentUrl)
                    }
                  />
                  {attachmentUrl && (
                    <Link to={attachmentUrl} target="_blank">
                      Attachment Link
                    </Link>
                  )}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    justifyContent: "flex-start",
                  }}
                >
                  {paramObject.id > 0 && (
                    <>
                      <div
                        className="btn btn-sm btn-secondary mt-3"
                        onClick={() => ParticularSupplierInvoiceAPI(0, 0)}
                      >
                        Revert
                      </div>
                      {checkUserPermission(DELETEPERMISSION) && (
                      <div
                        title="Delete"
                        data-bs-toggle="modal"
                        data-bs-target="#DeleteConfirmationModal"
                        className="btn btn-sm btn-secondary mt-3"
                        onClick={() => handleDeletePopup()}
                      >
                        Delete
                      </div>
                      )}
                    </>
                  )}
                </div>

                {(supplierInvoiceData?.length > 0 ||
                  supplierCreditData?.length > 0 ||
                  (totalReceivingAmountInput == 0
                    ? totalReceivingAmount
                    : totalReceivingAmountInput) > 0) && (
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                      justifyContent: "flex-end",
                    }}
                  >
                    <button
                      className="btn btn-sm btn-secondary mt-3 mb-3"
                      // onClick={() => navigate("/sales")}
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-sm btn-primary mt-3 mb-3"
                      onClick={(e) => SubmitReceivePayment("saveandclose")}
                    >
                      Save & Close
                    </button>
                    <button
                      className="btn btn-sm btn-secondary mt-3 mb-3"
                      onClick={(e) => SubmitReceivePayment("saveandnew")}
                    >
                      Save & New
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <PaybillsSteppermodal
          // customerId={customerId}
          // fileddata={fileddata}
          // previosdata={previosdata}
          receivedata={receivedata}
          fileddata={fileddata}
          module="QuickBookView"
          handleOpenExternal={(fn) => (handleOpenRef.current = fn)}
        />
        <DeleteConfirmation
          deleteApiUrl={`${config.accountingBaseUrl}/chartofaccounts/viewregisterdelete`}
          open={deleteModalOpen}
          onClose={() => setDeleteModalOpen(false)}
          openingbalance={0}
          isAccountingDelete={1}
        />
        <MissingTransaction value={missingtransactions} />
        <RollbackReceivePayment
          Open={IsRollback}
          RollbackOriginalId={RollbackOriginalId}
          RollbackId={RollbackId}
          handleClose={() => setIsRollback(false)}
        />
      </div>
      <RecentTransactionsModal transactionType="Bill Payment" id={7} />
    </>
  );
}

export default PayBillsQuickbook;
